import {
  Alert,
  Box,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from "@mui/material";
import { useMemo } from "react";
import { createMenuItems, FORM_CONSTANTS } from "./genericInfoFormUtils";
import BasicInfo from "./basicInfo.component";
import CultureInfo from "./cultureInfo.component";
import { useGenericInfoForm } from "./hooks/useGenericInfoForm";

const GenericInfoForm = ({
  fieldsType,
  irrigationTypes,
  crops,
  onSubmit,
  theme,
  onHasSubAreasChange,
  initialData = null,
  isEditMode = false,
}) => {
  const {
    register,
    handleSubmit,
    errors,
    startDate,
    endDate,
    isWarning,
    fieldName,
    fieldType,
    irrigationSystem,
    fieldCulture,
    hasSubAreas,
    today,
    handlers,
  } = useGenericInfoForm({
    initialData,
    isEditMode,
    onHasSubAreasChange,
  });
  const memoizedFieldTypes = useMemo(
    () => createMenuItems(fieldsType, FORM_CONSTANTS.MESSAGES.NO_OPTIONS),
    [fieldsType]
  );

  const memoizedIrrigationTypes = useMemo(
    () => createMenuItems(irrigationTypes, FORM_CONSTANTS.MESSAGES.NO_OPTIONS),
    [irrigationTypes]
  );

  const memoizedCrops = useMemo(
    () => createMenuItems(crops, FORM_CONSTANTS.MESSAGES.NO_OPTIONS),
    [crops]
  );

  return (
    <Box
      component="form"
      id="generic-info-form"
      onSubmit={handleSubmit(onSubmit)}
      display="flex"
      flexDirection="column"
      gap={2}
      mb={2}
      height="100%"
    >
      <BasicInfo
        isEditMode={isEditMode}
        theme={theme}
        errors={errors}
        register={register}
        initialData={initialData}
        fieldName={fieldName}
        fieldType={fieldType}
        irrigationSystem={irrigationSystem}
        memoizedFieldTypes={memoizedFieldTypes}
        memoizedIrrigationTypes={memoizedIrrigationTypes}
      />
      <CultureInfo
        initialData={initialData}
        register={register}
        memoizedCrops={memoizedCrops}
        startDate={startDate}
        handleStartDateSelect={handlers.handleStartDateSelect}
        errors={errors}
        fieldCulture={fieldCulture}
        endDate={endDate}
        handleEndDateSelect={handlers.handleEndDateSelect}
        today={today}
        isEditMode={isEditMode}
      />
      <Typography fontSize="14px" fontWeight="bold">
        Questo terreno è suddiviso in sottoterreni?
      </Typography>
      <FormControl>
        <RadioGroup
          aria-labelledby="field-radio-buttons-label"
          name="has_sub_field"
          value={hasSubAreas?.toString()}
          onChange={handlers.handleSubAreasChange}
        >
          <FormControlLabel
            value={FORM_CONSTANTS.RADIO_VALUES.TRUE}
            control={<Radio />}
            label="Si"
          />
          <FormControlLabel
            value={FORM_CONSTANTS.RADIO_VALUES.FALSE}
            control={<Radio />}
            label="No"
          />
        </RadioGroup>
      </FormControl>
      {isWarning && (
        <Alert severity="warning" sx={{ width: "auto" }}>
          {FORM_CONSTANTS.MESSAGES.NO_SUB_AREAS}
        </Alert>
      )}
    </Box>
  );
};

export default GenericInfoForm;
